import data from "../../../../../src/drafts/MarkdownViewer/MarkdownViewer.docs.json";
import * as React from 'react';
export default {
  data,
  React
};